@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(664_747_982)
internal val Res.string.lesson_hiero_verbs_3_title: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_3_title", "lesson_hiero_verbs_3_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180510, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177854, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179545, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 170978, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167094, 58),
      ))
    }

@delegate:ResourceContentHash(-1_715_238_636)
internal val Res.string.lesson_hiero_verbs_4_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_4_desc", "lesson_hiero_verbs_4_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180573, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 177913, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179608, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171037, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167153, 109),
      ))
    }

@delegate:ResourceContentHash(-331_042_619)
internal val Res.string.lesson_hiero_verbs_4_title: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_4_title", "lesson_hiero_verbs_4_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180675, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178043, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179734, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171151, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167263, 54),
      ))
    }

@delegate:ResourceContentHash(-2_090_771_438)
internal val Res.string.lesson_hiero_verbs_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_desc", "lesson_hiero_verbs_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180734, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178102, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179793, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171206, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167318, 91),
      ))
    }

@delegate:ResourceContentHash(-552_744_260)
internal val Res.string.lesson_hiero_verbs_title: StringResource by lazy {
      StringResource("string:lesson_hiero_verbs_title", "lesson_hiero_verbs_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180862, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178210, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179901, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171302, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167410, 52),
      ))
    }

@delegate:ResourceContentHash(-81_660_063)
internal val Res.string.lesson_hiero_vso_1_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_vso_1_desc", "lesson_hiero_vso_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 180919, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178267, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 179958, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171355, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167463, 119),
      ))
    }

@delegate:ResourceContentHash(-259_487_468)
internal val Res.string.lesson_hiero_vso_1_title: StringResource by lazy {
      StringResource("string:lesson_hiero_vso_1_title", "lesson_hiero_vso_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181051, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178403, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180090, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171475, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167583, 76),
      ))
    }

@delegate:ResourceContentHash(-712_559_872)
internal val Res.string.lesson_hiero_vso_2_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_vso_2_desc", "lesson_hiero_vso_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181132, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178484, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180171, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171552, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167660, 119),
      ))
    }

@delegate:ResourceContentHash(106_039_100)
internal val Res.string.lesson_hiero_vso_2_title: StringResource by lazy {
      StringResource("string:lesson_hiero_vso_2_title", "lesson_hiero_vso_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181260, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178612, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180307, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171660, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167780, 76),
      ))
    }

@delegate:ResourceContentHash(-993_102_331)
internal val Res.string.lesson_hiero_vso_3_desc: StringResource by lazy {
      StringResource("string:lesson_hiero_vso_3_desc", "lesson_hiero_vso_3_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181349, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178697, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180392, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171737, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167857, 115),
      ))
    }

@delegate:ResourceContentHash(-744_871_180)
internal val Res.string.lesson_hiero_vso_3_title: StringResource by lazy {
      StringResource("string:lesson_hiero_vso_3_title", "lesson_hiero_vso_3_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181461, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178825, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180516, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171845, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167973, 72),
      ))
    }

@delegate:ResourceContentHash(-563_800_124)
internal val Res.string.lesson_il_dimostrativo_pn_desc: StringResource by lazy {
      StringResource("string:lesson_il_dimostrativo_pn_desc", "lesson_il_dimostrativo_pn_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181538, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178902, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180593, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 171918, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168046, 78),
      ))
    }

@delegate:ResourceContentHash(-1_638_907_370)
internal val Res.string.lesson_il_dimostrativo_pn_title: StringResource by lazy {
      StringResource("string:lesson_il_dimostrativo_pn_title", "lesson_il_dimostrativo_pn_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181625, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 178993, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180684, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172017, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168125, 59),
      ))
    }

@delegate:ResourceContentHash(299_877_846)
internal val Res.string.lesson_il_genitivo_diretto_desc: StringResource by lazy {
      StringResource("string:lesson_il_genitivo_diretto_desc", "lesson_il_genitivo_diretto_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181689, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179053, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180744, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172077, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168185, 67),
      ))
    }

@delegate:ResourceContentHash(1_337_763_244)
internal val Res.string.lesson_il_genitivo_diretto_title: StringResource by lazy {
      StringResource("string:lesson_il_genitivo_diretto_title", "lesson_il_genitivo_diretto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181757, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179121, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180812, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172141, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168253, 60),
      ))
    }

@delegate:ResourceContentHash(277_566_830)
internal val Res.string.lesson_il_genitivo_indiretto_desc: StringResource by lazy {
      StringResource("string:lesson_il_genitivo_indiretto_desc", "lesson_il_genitivo_indiretto_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181826, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179190, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180873, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172210, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168314, 89),
      ))
    }

@delegate:ResourceContentHash(486_891_486)
internal val Res.string.lesson_il_genitivo_indiretto_title: StringResource by lazy {
      StringResource("string:lesson_il_genitivo_indiretto_title", "lesson_il_genitivo_indiretto_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181912, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179280, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 180979, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172300, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168404, 66),
      ))
    }

@delegate:ResourceContentHash(1_650_846_938)
internal val Res.string.lesson_il_grande_ritorno_desc: StringResource by lazy {
      StringResource("string:lesson_il_grande_ritorno_desc", "lesson_il_grande_ritorno_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 181983, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179351, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181046, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172371, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168471, 69),
      ))
    }

@delegate:ResourceContentHash(-1_608_490_824)
internal val Res.string.lesson_il_grande_ritorno_title: StringResource by lazy {
      StringResource("string:lesson_il_grande_ritorno_title", "lesson_il_grande_ritorno_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182049, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179417, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181112, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172437, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168541, 62),
      ))
    }

@delegate:ResourceContentHash(-1_856_888_963)
internal val Res.string.lesson_il_segreto_della_piramide_desc: StringResource by lazy {
      StringResource("string:lesson_il_segreto_della_piramide_desc", "lesson_il_segreto_della_piramide_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182116, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179476, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181171, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172500, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168604, 101),
      ))
    }

@delegate:ResourceContentHash(215_188_392)
internal val Res.string.lesson_il_segreto_della_piramide_title: StringResource by lazy {
      StringResource("string:lesson_il_segreto_della_piramide_title", "lesson_il_segreto_della_piramide_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182210, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179590, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181277, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172602, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168706, 70),
      ))
    }

@delegate:ResourceContentHash(567_363_271)
internal val Res.string.lesson_il_tema_verbale_sdm_f_desc: StringResource by lazy {
      StringResource("string:lesson_il_tema_verbale_sdm_f_desc", "lesson_il_tema_verbale_sdm_f_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182293, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179665, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181360, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172681, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168777, 81),
      ))
    }

@delegate:ResourceContentHash(-2_144_432_384)
internal val Res.string.lesson_il_tema_verbale_sdm_f_title: StringResource by lazy {
      StringResource("string:lesson_il_tema_verbale_sdm_f_title", "lesson_il_tema_verbale_sdm_f_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182379, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179743, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181442, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172759, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168859, 70),
      ))
    }

@delegate:ResourceContentHash(633_652_290)
internal val Res.string.lesson_il_verbo_ma_i_desc: StringResource by lazy {
      StringResource("string:lesson_il_verbo_ma_i_desc", "lesson_il_verbo_ma_i_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182450, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179814, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181517, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172830, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168930, 77),
      ))
    }

@delegate:ResourceContentHash(-1_058_542_234)
internal val Res.string.lesson_il_verbo_ma_i_title: StringResource by lazy {
      StringResource("string:lesson_il_verbo_ma_i_title", "lesson_il_verbo_ma_i_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182540, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179896, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181603, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172912, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169008, 54),
      ))
    }

@delegate:ResourceContentHash(-1_165_612_341)
internal val Res.string.lesson_in_viaggio_sul_nilo_desc: StringResource by lazy {
      StringResource("string:lesson_in_viaggio_sul_nilo_desc", "lesson_in_viaggio_sul_nilo_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182591, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 179951, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181654, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 172963, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169063, 79),
      ))
    }

@delegate:ResourceContentHash(-158_260_677)
internal val Res.string.lesson_in_viaggio_sul_nilo_title: StringResource by lazy {
      StringResource("string:lesson_in_viaggio_sul_nilo_title", "lesson_in_viaggio_sul_nilo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182683, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180035, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181738, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173035, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169143, 52),
      ))
    }

@delegate:ResourceContentHash(-1_831_252_660)
internal val Res.string.lesson_intro_hieroglyphs_2_desc: StringResource by lazy {
      StringResource("string:lesson_intro_hieroglyphs_2_desc", "lesson_intro_hieroglyphs_2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182740, 183),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180092, 171),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181799, 175),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173092, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169196, 147),
      ))
    }

@delegate:ResourceContentHash(-1_719_411_861)
internal val Res.string.lesson_intro_hieroglyphs_2_title: StringResource by lazy {
      StringResource("string:lesson_intro_hieroglyphs_2_title", "lesson_intro_hieroglyphs_2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182924, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180264, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 181975, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173256, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169344, 68),
      ))
    }

@delegate:ResourceContentHash(1_348_507_359)
internal val Res.string.lesson_intro_hieroglyphs_desc: StringResource by lazy {
      StringResource("string:lesson_intro_hieroglyphs_desc", "lesson_intro_hieroglyphs_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 182997, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180341, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182048, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173325, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169413, 137),
      ))
    }

@delegate:ResourceContentHash(-1_786_188_097)
internal val Res.string.lesson_intro_hieroglyphs_title: StringResource by lazy {
      StringResource("string:lesson_intro_hieroglyphs_title", "lesson_intro_hieroglyphs_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183155, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180491, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182210, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173471, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169551, 74),
      ))
    }

@delegate:ResourceContentHash(71_086_139)
internal val Res.string.lesson_intro_vso_8_desc: StringResource by lazy {
      StringResource("string:lesson_intro_vso_8_desc", "lesson_intro_vso_8_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183238, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180574, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182289, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173546, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169626, 79),
      ))
    }

@delegate:ResourceContentHash(-1_102_918_196)
internal val Res.string.lesson_intro_vso_8_title: StringResource by lazy {
      StringResource("string:lesson_intro_vso_8_title", "lesson_intro_vso_8_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183314, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180666, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182377, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173638, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169706, 48),
      ))
    }

@delegate:ResourceContentHash(-286_258_453)
internal val Res.string.lesson_intro_vso_desc: StringResource by lazy {
      StringResource("string:lesson_intro_vso_desc", "lesson_intro_vso_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183363, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180715, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182426, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173687, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169755, 49),
      ))
    }

@delegate:ResourceContentHash(285_456_756)
internal val Res.string.lesson_intro_vso_title: StringResource by lazy {
      StringResource("string:lesson_intro_vso_title", "lesson_intro_vso_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183409, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180777, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182476, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173741, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169805, 46),
      ))
    }

@delegate:ResourceContentHash(-1_014_795_665)
internal val Res.string.lesson_l_infinito_desc: StringResource by lazy {
      StringResource("string:lesson_l_infinito_desc", "lesson_l_infinito_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183456, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180832, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182523, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173796, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169852, 78),
      ))
    }

@delegate:ResourceContentHash(-511_602_560)
internal val Res.string.lesson_l_infinito_title: StringResource by lazy {
      StringResource("string:lesson_l_infinito_title", "lesson_l_infinito_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183543, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180919, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182606, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173879, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169931, 51),
      ))
    }

@delegate:ResourceContentHash(1_844_324_420)
internal val Res.string.lesson_la_forma_vso_desc: StringResource by lazy {
      StringResource("string:lesson_la_forma_vso_desc", "lesson_la_forma_vso_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183595, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 180971, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182654, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 173927, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169983, 88),
      ))
    }

@delegate:ResourceContentHash(-1_102_918_196)
internal val Res.string.lesson_la_forma_vso_title: StringResource by lazy {
      StringResource("string:lesson_la_forma_vso_title", "lesson_la_forma_vso_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183680, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181064, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182743, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174012, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170072, 49),
      ))
    }

@delegate:ResourceContentHash(-1_580_513_722)
internal val Res.string.lesson_la_frase_misteriosa_desc: StringResource by lazy {
      StringResource("string:lesson_la_frase_misteriosa_desc", "lesson_la_frase_misteriosa_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183730, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181114, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182793, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174062, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170122, 67),
      ))
    }

@delegate:ResourceContentHash(-693_275_093)
internal val Res.string.lesson_la_frase_misteriosa_title: StringResource by lazy {
      StringResource("string:lesson_la_frase_misteriosa_title", "lesson_la_frase_misteriosa_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183806, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181198, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182865, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174122, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170190, 72),
      ))
    }

@delegate:ResourceContentHash(21_217_825)
internal val Res.string.lesson_la_particella_ni_desc: StringResource by lazy {
      StringResource("string:lesson_la_particella_ni_desc", "lesson_la_particella_ni_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183879, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181267, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182938, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174191, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170263, 80),
      ))
    }

@delegate:ResourceContentHash(1_362_839_384)
internal val Res.string.lesson_la_particella_ni_title: StringResource by lazy {
      StringResource("string:lesson_la_particella_ni_title", "lesson_la_particella_ni_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 183952, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181352, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183023, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174268, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170344, 49),
      ))
    }

@delegate:ResourceContentHash(-248_942_176)
internal val Res.string.lesson_la_pazienza_e_finita_desc: StringResource by lazy {
      StringResource("string:lesson_la_pazienza_e_finita_desc", "lesson_la_pazienza_e_finita_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184014, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181418, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183085, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174330, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170394, 64),
      ))
    }

@delegate:ResourceContentHash(1_824_085_238)
internal val Res.string.lesson_la_pazienza_e_finita_title: StringResource by lazy {
      StringResource("string:lesson_la_pazienza_e_finita_title", "lesson_la_pazienza_e_finita_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184079, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181483, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183150, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174387, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170459, 69),
      ))
    }

@delegate:ResourceContentHash(1_913_827_062)
internal val Res.string.lesson_la_teoria_desc: StringResource by lazy {
      StringResource("string:lesson_la_teoria_desc", "lesson_la_teoria_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184153, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181565, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183228, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174457, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170529, 81),
      ))
    }

@delegate:ResourceContentHash(-1_154_579_577)
internal val Res.string.lesson_la_teoria_title: StringResource by lazy {
      StringResource("string:lesson_la_teoria_title", "lesson_la_teoria_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184239, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181655, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183326, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174535, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170611, 38),
      ))
    }

@delegate:ResourceContentHash(-1_659_839_099)
internal val Res.string.lesson_le_frasi_avverbiali_desc: StringResource by lazy {
      StringResource("string:lesson_le_frasi_avverbiali_desc", "lesson_le_frasi_avverbiali_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184286, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181702, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183369, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174578, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170650, 87),
      ))
    }

@delegate:ResourceContentHash(-2_011_308_783)
internal val Res.string.lesson_le_frasi_avverbiali_title: StringResource by lazy {
      StringResource("string:lesson_le_frasi_avverbiali_title", "lesson_le_frasi_avverbiali_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184370, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181786, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183457, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174658, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170738, 68),
      ))
    }

@delegate:ResourceContentHash(256_550_128)
internal val Res.string.lesson_le_preposizioni_desc: StringResource by lazy {
      StringResource("string:lesson_le_preposizioni_desc", "lesson_le_preposizioni_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184431, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181859, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183526, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174727, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170807, 75),
      ))
    }

@delegate:ResourceContentHash(2_054_025_733)
internal val Res.string.lesson_le_preposizioni_title: StringResource by lazy {
      StringResource("string:lesson_le_preposizioni_title", "lesson_le_preposizioni_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184515, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 181947, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183610, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174807, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170883, 52),
      ))
    }

@delegate:ResourceContentHash(-1_607_488_527)
internal val Res.string.lesson_liste_nomi_desc: StringResource by lazy {
      StringResource("string:lesson_liste_nomi_desc", "lesson_liste_nomi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184572, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182004, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183667, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 174864, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170936, 142),
      ))
    }

@delegate:ResourceContentHash(-1_005_126_506)
internal val Res.string.lesson_liste_nomi_title: StringResource by lazy {
      StringResource("string:lesson_liste_nomi_title", "lesson_liste_nomi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184735, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182147, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183814, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175003, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171079, 51),
      ))
    }

@delegate:ResourceContentHash(1_899_737_941)
internal val Res.string.lesson_mi_ti_srw_desc: StringResource by lazy {
      StringResource("string:lesson_mi_ti_srw_desc", "lesson_mi_ti_srw_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184799, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182207, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183866, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175063, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171131, 73),
      ))
    }

@delegate:ResourceContentHash(878_230_851)
internal val Res.string.lesson_mi_ti_srw_title: StringResource by lazy {
      StringResource("string:lesson_mi_ti_srw_title", "lesson_mi_ti_srw_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184881, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182289, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 183940, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175129, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171205, 58),
      ))
    }

@delegate:ResourceContentHash(2_042_864_595)
internal val Res.string.lesson_mysterious_cartouche_desc: StringResource by lazy {
      StringResource("string:lesson_mysterious_cartouche_desc", "lesson_mysterious_cartouche_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 184948, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182352, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184007, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175192, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171264, 116),
      ))
    }

@delegate:ResourceContentHash(1_343_475_663)
internal val Res.string.lesson_mysterious_cartouche_title: StringResource by lazy {
      StringResource("string:lesson_mysterious_cartouche_title", "lesson_mysterious_cartouche_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185081, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182477, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184136, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175305, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171381, 73),
      ))
    }

@delegate:ResourceContentHash(1_316_881_815)
internal val Res.string.lesson_nomi_e_aggettivi_1_desc: StringResource by lazy {
      StringResource("string:lesson_nomi_e_aggettivi_1_desc", "lesson_nomi_e_aggettivi_1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185159, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182551, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184210, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175379, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171455, 78),
      ))
    }

@delegate:ResourceContentHash(-646_629_071)
internal val Res.string.lesson_nomi_e_aggettivi_1_title: StringResource by lazy {
      StringResource("string:lesson_nomi_e_aggettivi_1_title", "lesson_nomi_e_aggettivi_1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185254, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182642, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184305, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175466, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171534, 71),
      ))
    }

@delegate:ResourceContentHash(686_425_411)
internal val Res.string.lesson_nomi_importanti_desc: StringResource by lazy {
      StringResource("string:lesson_nomi_importanti_desc", "lesson_nomi_importanti_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185322, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182718, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184373, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175530, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171606, 75),
      ))
    }

@delegate:ResourceContentHash(1_321_537_763)
internal val Res.string.lesson_nomi_importanti_title: StringResource by lazy {
      StringResource("string:lesson_nomi_importanti_title", "lesson_nomi_importanti_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185386, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182782, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184449, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175602, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171682, 56),
      ))
    }

@delegate:ResourceContentHash(-1_607_719_803)
internal val Res.string.lesson_nomi_nomi_nomi_desc: StringResource by lazy {
      StringResource("string:lesson_nomi_nomi_nomi_desc", "lesson_nomi_nomi_nomi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185443, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182847, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184514, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175659, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171739, 62),
      ))
    }

@delegate:ResourceContentHash(218_049_954)
internal val Res.string.lesson_nomi_nomi_nomi_title: StringResource by lazy {
      StringResource("string:lesson_nomi_nomi_nomi_title", "lesson_nomi_nomi_nomi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185510, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182910, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184589, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175730, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171802, 63),
      ))
    }

@delegate:ResourceContentHash(-864_015_158)
internal val Res.string.lesson_number_gender_desc: StringResource by lazy {
      StringResource("string:lesson_number_gender_desc", "lesson_number_gender_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185574, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182986, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184665, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175790, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171866, 129),
      ))
    }

@delegate:ResourceContentHash(-425_364_665)
internal val Res.string.lesson_number_gender_title: StringResource by lazy {
      StringResource("string:lesson_number_gender_title", "lesson_number_gender_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185716, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183128, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184795, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175912, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171996, 58),
      ))
    }

@delegate:ResourceContentHash(-1_632_307_647)
internal val Res.string.lesson_oggetto_frase_desc: StringResource by lazy {
      StringResource("string:lesson_oggetto_frase_desc", "lesson_oggetto_frase_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185779, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183187, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184850, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175967, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172055, 77),
      ))
    }

@delegate:ResourceContentHash(-1_580_057_208)
internal val Res.string.lesson_oggetto_frase_title: StringResource by lazy {
      StringResource("string:lesson_oggetto_frase_title", "lesson_oggetto_frase_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185861, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183277, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184928, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176053, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172133, 70),
      ))
    }

@delegate:ResourceContentHash(-1_629_454_373)
internal val Res.string.lesson_parole_del_tempo_desc: StringResource by lazy {
      StringResource("string:lesson_parole_del_tempo_desc", "lesson_parole_del_tempo_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 185924, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183340, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176116, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172204, 80),
      ))
    }

@delegate:ResourceContentHash(1_732_062_334)
internal val Res.string.lesson_parole_del_tempo_title: StringResource by lazy {
      StringResource("string:lesson_parole_del_tempo_title", "lesson_parole_del_tempo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186017, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183425, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176193, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172285, 57),
      ))
    }

@delegate:ResourceContentHash(-1_832_168_686)
internal val Res.string.lesson_parole_di_luoghi_desc: StringResource by lazy {
      StringResource("string:lesson_parole_di_luoghi_desc", "lesson_parole_di_luoghi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186079, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183491, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 184991, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176255, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172343, 80),
      ))
    }

@delegate:ResourceContentHash(-2_126_891_608)
internal val Res.string.lesson_parole_di_luoghi_title: StringResource by lazy {
      StringResource("string:lesson_parole_di_luoghi_title", "lesson_parole_di_luoghi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186160, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183576, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185076, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176332, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172424, 57),
      ))
    }

@delegate:ResourceContentHash(1_417_721_410)
internal val Res.string.lesson_participi_intro_desc: StringResource by lazy {
      StringResource("string:lesson_participi_intro_desc", "lesson_participi_intro_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186222, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183642, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185134, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176394, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172482, 95),
      ))
    }

@delegate:ResourceContentHash(-1_454_463_697)
internal val Res.string.lesson_participi_intro_title: StringResource by lazy {
      StringResource("string:lesson_participi_intro_title", "lesson_participi_intro_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186326, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183742, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185234, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176478, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172578, 52),
      ))
    }

@delegate:ResourceContentHash(-343_173_925)
internal val Res.string.lesson_particle_iw_desc: StringResource by lazy {
      StringResource("string:lesson_particle_iw_desc", "lesson_particle_iw_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186379, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183799, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185287, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176531, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172631, 107),
      ))
    }

@delegate:ResourceContentHash(1_107_238_088)
internal val Res.string.lesson_particle_iw_title: StringResource by lazy {
      StringResource("string:lesson_particle_iw_title", "lesson_particle_iw_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186491, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183899, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185391, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176627, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172739, 56),
      ))
    }

@delegate:ResourceContentHash(-232_047_914)
internal val Res.string.lesson_phonetic_complements_desc: StringResource by lazy {
      StringResource("string:lesson_phonetic_complements_desc", "lesson_phonetic_complements_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186548, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 183956, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185448, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176684, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172796, 100),
      ))
    }

@delegate:ResourceContentHash(2_129_230_969)
internal val Res.string.lesson_phonetic_complements_title: StringResource by lazy {
      StringResource("string:lesson_phonetic_complements_title", "lesson_phonetic_complements_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186673, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184085, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185581, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176809, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172897, 69),
      ))
    }

@delegate:ResourceContentHash(1_229_495_655)
internal val Res.string.lesson_possessivo_suffisso_desc: StringResource by lazy {
      StringResource("string:lesson_possessivo_suffisso_desc", "lesson_possessivo_suffisso_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186747, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184159, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185659, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176879, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 172967, 67),
      ))
    }

@delegate:ResourceContentHash(1_777_659_282)
internal val Res.string.lesson_possessivo_suffisso_title: StringResource by lazy {
      StringResource("string:lesson_possessivo_suffisso_title", "lesson_possessivo_suffisso_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186815, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184235, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185735, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 176951, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173035, 56),
      ))
    }

@delegate:ResourceContentHash(859_902_095)
internal val Res.string.lesson_preposizione_dr_desc: StringResource by lazy {
      StringResource("string:lesson_preposizione_dr_desc", "lesson_preposizione_dr_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186876, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184296, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185792, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177008, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173092, 67),
      ))
    }

@delegate:ResourceContentHash(-70_261_631)
internal val Res.string.lesson_preposizione_dr_title: StringResource by lazy {
      StringResource("string:lesson_preposizione_dr_title", "lesson_preposizione_dr_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 186944, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184376, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185864, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177076, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173160, 64),
      ))
    }

@delegate:ResourceContentHash(-885_960_703)
internal val Res.string.lesson_preposizione_hr_desc: StringResource by lazy {
      StringResource("string:lesson_preposizione_hr_desc", "lesson_preposizione_hr_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187009, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184441, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185929, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177141, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173225, 55),
      ))
    }

@delegate:ResourceContentHash(542_160_070)
internal val Res.string.lesson_preposizione_hr_title: StringResource by lazy {
      StringResource("string:lesson_preposizione_hr_title", "lesson_preposizione_hr_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187073, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184501, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 185989, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177201, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173281, 64),
      ))
    }

@delegate:ResourceContentHash(156_955_745)
internal val Res.string.lesson_preposizione_m_desc: StringResource by lazy {
      StringResource("string:lesson_preposizione_m_desc", "lesson_preposizione_m_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187138, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184566, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186054, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177266, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173346, 74),
      ))
    }

@delegate:ResourceContentHash(1_020_890_988)
internal val Res.string.lesson_preposizione_m_locativa_desc: StringResource by lazy {
      StringResource("string:lesson_preposizione_m_locativa_desc", "lesson_preposizione_m_locativa_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187213, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184645, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177337, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173421, 71),
      ))
    }

@delegate:ResourceContentHash(-1_589_856_536)
internal val Res.string.lesson_preposizione_m_locativa_title: StringResource by lazy {
      StringResource("string:lesson_preposizione_m_locativa_title", "lesson_preposizione_m_locativa_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187293, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184717, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177413, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173493, 68),
      ))
    }

@delegate:ResourceContentHash(-1_277_199_989)
internal val Res.string.lesson_preposizione_m_title: StringResource by lazy {
      StringResource("string:lesson_preposizione_m_title", "lesson_preposizione_m_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187362, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184786, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186145, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177482, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173562, 63),
      ))
    }

@delegate:ResourceContentHash(-1_780_298_855)
internal val Res.string.lesson_recap_frasi_pseudoverbali_desc: StringResource by lazy {
      StringResource("string:lesson_recap_frasi_pseudoverbali_desc", "lesson_recap_frasi_pseudoverbali_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187426, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184850, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186209, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177542, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173626, 121),
      ))
    }

@delegate:ResourceContentHash(37_687_716)
internal val Res.string.lesson_recap_frasi_pseudoverbali_title: StringResource by lazy {
      StringResource("string:lesson_recap_frasi_pseudoverbali_title", "lesson_recap_frasi_pseudoverbali_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187540, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 184980, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186331, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177660, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173748, 54),
      ))
    }

@delegate:ResourceContentHash(-330_925_458)
internal val Res.string.lesson_recap_imperfettivo_desc: StringResource by lazy {
      StringResource("string:lesson_recap_imperfettivo_desc", "lesson_recap_imperfettivo_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187603, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185035, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186390, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177719, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173803, 74),
      ))
    }

@delegate:ResourceContentHash(-1_126_737_450)
internal val Res.string.lesson_recap_imperfettivo_title: StringResource by lazy {
      StringResource("string:lesson_recap_imperfettivo_title", "lesson_recap_imperfettivo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187678, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185126, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186469, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177806, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173878, 47),
      ))
    }

@delegate:ResourceContentHash(-1_971_149_016)
internal val Res.string.lesson_recap_verbi_participi_desc: StringResource by lazy {
      StringResource("string:lesson_recap_verbi_participi_desc", "lesson_recap_verbi_participi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187730, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185182, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186521, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177862, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 173926, 101),
      ))
    }

@delegate:ResourceContentHash(-1_762_368_880)
internal val Res.string.lesson_recap_verbi_participi_title: StringResource by lazy {
      StringResource("string:lesson_recap_verbi_participi_title", "lesson_recap_verbi_participi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187836, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185304, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186639, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 177972, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174028, 82),
      ))
    }

@delegate:ResourceContentHash(-1_260_245_793)
internal val Res.string.lesson_recap_vso_desc: StringResource by lazy {
      StringResource("string:lesson_recap_vso_desc", "lesson_recap_vso_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 187927, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185387, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186722, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178051, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174111, 81),
      ))
    }

@delegate:ResourceContentHash(-167_898_281)
internal val Res.string.lesson_recap_vso_title: StringResource by lazy {
      StringResource("string:lesson_recap_vso_title", "lesson_recap_vso_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188037, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185465, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186816, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178137, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174193, 46),
      ))
    }

@delegate:ResourceContentHash(-1_594_317_181)
internal val Res.string.lesson_rieccolo_di_nuovo_desc: StringResource by lazy {
      StringResource("string:lesson_rieccolo_di_nuovo_desc", "lesson_rieccolo_di_nuovo_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188104, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185512, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186863, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178184, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174240, 85),
      ))
    }

@delegate:ResourceContentHash(-269_817_301)
internal val Res.string.lesson_rieccolo_di_nuovo_title: StringResource by lazy {
      StringResource("string:lesson_rieccolo_di_nuovo_title", "lesson_rieccolo_di_nuovo_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188190, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185590, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 186949, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178262, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174326, 62),
      ))
    }

@delegate:ResourceContentHash(889_036_498)
internal val Res.string.lesson_ripassino_aggettivi_desc: StringResource by lazy {
      StringResource("string:lesson_ripassino_aggettivi_desc", "lesson_ripassino_aggettivi_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188253, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185661, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187008, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178325, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174389, 91),
      ))
    }

@delegate:ResourceContentHash(856_626_995)
internal val Res.string.lesson_ripassino_aggettivi_title: StringResource by lazy {
      StringResource("string:lesson_ripassino_aggettivi_title", "lesson_ripassino_aggettivi_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188337, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185753, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187096, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178417, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174481, 56),
      ))
    }

@delegate:ResourceContentHash(-348_091_795)
internal val Res.string.lesson_ripasso_genere_numero_desc: StringResource by lazy {
      StringResource("string:lesson_ripasso_genere_numero_desc", "lesson_ripasso_genere_numero_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 188390, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 185822, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187153, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 178474, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174538, 113),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString17Resources(map: MutableMap<String, StringResource>) {
  map.put("lesson_hiero_verbs_3_title", Res.string.lesson_hiero_verbs_3_title)
  map.put("lesson_hiero_verbs_4_desc", Res.string.lesson_hiero_verbs_4_desc)
  map.put("lesson_hiero_verbs_4_title", Res.string.lesson_hiero_verbs_4_title)
  map.put("lesson_hiero_verbs_desc", Res.string.lesson_hiero_verbs_desc)
  map.put("lesson_hiero_verbs_title", Res.string.lesson_hiero_verbs_title)
  map.put("lesson_hiero_vso_1_desc", Res.string.lesson_hiero_vso_1_desc)
  map.put("lesson_hiero_vso_1_title", Res.string.lesson_hiero_vso_1_title)
  map.put("lesson_hiero_vso_2_desc", Res.string.lesson_hiero_vso_2_desc)
  map.put("lesson_hiero_vso_2_title", Res.string.lesson_hiero_vso_2_title)
  map.put("lesson_hiero_vso_3_desc", Res.string.lesson_hiero_vso_3_desc)
  map.put("lesson_hiero_vso_3_title", Res.string.lesson_hiero_vso_3_title)
  map.put("lesson_il_dimostrativo_pn_desc", Res.string.lesson_il_dimostrativo_pn_desc)
  map.put("lesson_il_dimostrativo_pn_title", Res.string.lesson_il_dimostrativo_pn_title)
  map.put("lesson_il_genitivo_diretto_desc", Res.string.lesson_il_genitivo_diretto_desc)
  map.put("lesson_il_genitivo_diretto_title", Res.string.lesson_il_genitivo_diretto_title)
  map.put("lesson_il_genitivo_indiretto_desc", Res.string.lesson_il_genitivo_indiretto_desc)
  map.put("lesson_il_genitivo_indiretto_title", Res.string.lesson_il_genitivo_indiretto_title)
  map.put("lesson_il_grande_ritorno_desc", Res.string.lesson_il_grande_ritorno_desc)
  map.put("lesson_il_grande_ritorno_title", Res.string.lesson_il_grande_ritorno_title)
  map.put("lesson_il_segreto_della_piramide_desc", Res.string.lesson_il_segreto_della_piramide_desc)
  map.put("lesson_il_segreto_della_piramide_title", Res.string.lesson_il_segreto_della_piramide_title)
  map.put("lesson_il_tema_verbale_sdm_f_desc", Res.string.lesson_il_tema_verbale_sdm_f_desc)
  map.put("lesson_il_tema_verbale_sdm_f_title", Res.string.lesson_il_tema_verbale_sdm_f_title)
  map.put("lesson_il_verbo_ma_i_desc", Res.string.lesson_il_verbo_ma_i_desc)
  map.put("lesson_il_verbo_ma_i_title", Res.string.lesson_il_verbo_ma_i_title)
  map.put("lesson_in_viaggio_sul_nilo_desc", Res.string.lesson_in_viaggio_sul_nilo_desc)
  map.put("lesson_in_viaggio_sul_nilo_title", Res.string.lesson_in_viaggio_sul_nilo_title)
  map.put("lesson_intro_hieroglyphs_2_desc", Res.string.lesson_intro_hieroglyphs_2_desc)
  map.put("lesson_intro_hieroglyphs_2_title", Res.string.lesson_intro_hieroglyphs_2_title)
  map.put("lesson_intro_hieroglyphs_desc", Res.string.lesson_intro_hieroglyphs_desc)
  map.put("lesson_intro_hieroglyphs_title", Res.string.lesson_intro_hieroglyphs_title)
  map.put("lesson_intro_vso_8_desc", Res.string.lesson_intro_vso_8_desc)
  map.put("lesson_intro_vso_8_title", Res.string.lesson_intro_vso_8_title)
  map.put("lesson_intro_vso_desc", Res.string.lesson_intro_vso_desc)
  map.put("lesson_intro_vso_title", Res.string.lesson_intro_vso_title)
  map.put("lesson_l_infinito_desc", Res.string.lesson_l_infinito_desc)
  map.put("lesson_l_infinito_title", Res.string.lesson_l_infinito_title)
  map.put("lesson_la_forma_vso_desc", Res.string.lesson_la_forma_vso_desc)
  map.put("lesson_la_forma_vso_title", Res.string.lesson_la_forma_vso_title)
  map.put("lesson_la_frase_misteriosa_desc", Res.string.lesson_la_frase_misteriosa_desc)
  map.put("lesson_la_frase_misteriosa_title", Res.string.lesson_la_frase_misteriosa_title)
  map.put("lesson_la_particella_ni_desc", Res.string.lesson_la_particella_ni_desc)
  map.put("lesson_la_particella_ni_title", Res.string.lesson_la_particella_ni_title)
  map.put("lesson_la_pazienza_e_finita_desc", Res.string.lesson_la_pazienza_e_finita_desc)
  map.put("lesson_la_pazienza_e_finita_title", Res.string.lesson_la_pazienza_e_finita_title)
  map.put("lesson_la_teoria_desc", Res.string.lesson_la_teoria_desc)
  map.put("lesson_la_teoria_title", Res.string.lesson_la_teoria_title)
  map.put("lesson_le_frasi_avverbiali_desc", Res.string.lesson_le_frasi_avverbiali_desc)
  map.put("lesson_le_frasi_avverbiali_title", Res.string.lesson_le_frasi_avverbiali_title)
  map.put("lesson_le_preposizioni_desc", Res.string.lesson_le_preposizioni_desc)
  map.put("lesson_le_preposizioni_title", Res.string.lesson_le_preposizioni_title)
  map.put("lesson_liste_nomi_desc", Res.string.lesson_liste_nomi_desc)
  map.put("lesson_liste_nomi_title", Res.string.lesson_liste_nomi_title)
  map.put("lesson_mi_ti_srw_desc", Res.string.lesson_mi_ti_srw_desc)
  map.put("lesson_mi_ti_srw_title", Res.string.lesson_mi_ti_srw_title)
  map.put("lesson_mysterious_cartouche_desc", Res.string.lesson_mysterious_cartouche_desc)
  map.put("lesson_mysterious_cartouche_title", Res.string.lesson_mysterious_cartouche_title)
  map.put("lesson_nomi_e_aggettivi_1_desc", Res.string.lesson_nomi_e_aggettivi_1_desc)
  map.put("lesson_nomi_e_aggettivi_1_title", Res.string.lesson_nomi_e_aggettivi_1_title)
  map.put("lesson_nomi_importanti_desc", Res.string.lesson_nomi_importanti_desc)
  map.put("lesson_nomi_importanti_title", Res.string.lesson_nomi_importanti_title)
  map.put("lesson_nomi_nomi_nomi_desc", Res.string.lesson_nomi_nomi_nomi_desc)
  map.put("lesson_nomi_nomi_nomi_title", Res.string.lesson_nomi_nomi_nomi_title)
  map.put("lesson_number_gender_desc", Res.string.lesson_number_gender_desc)
  map.put("lesson_number_gender_title", Res.string.lesson_number_gender_title)
  map.put("lesson_oggetto_frase_desc", Res.string.lesson_oggetto_frase_desc)
  map.put("lesson_oggetto_frase_title", Res.string.lesson_oggetto_frase_title)
  map.put("lesson_parole_del_tempo_desc", Res.string.lesson_parole_del_tempo_desc)
  map.put("lesson_parole_del_tempo_title", Res.string.lesson_parole_del_tempo_title)
  map.put("lesson_parole_di_luoghi_desc", Res.string.lesson_parole_di_luoghi_desc)
  map.put("lesson_parole_di_luoghi_title", Res.string.lesson_parole_di_luoghi_title)
  map.put("lesson_participi_intro_desc", Res.string.lesson_participi_intro_desc)
  map.put("lesson_participi_intro_title", Res.string.lesson_participi_intro_title)
  map.put("lesson_particle_iw_desc", Res.string.lesson_particle_iw_desc)
  map.put("lesson_particle_iw_title", Res.string.lesson_particle_iw_title)
  map.put("lesson_phonetic_complements_desc", Res.string.lesson_phonetic_complements_desc)
  map.put("lesson_phonetic_complements_title", Res.string.lesson_phonetic_complements_title)
  map.put("lesson_possessivo_suffisso_desc", Res.string.lesson_possessivo_suffisso_desc)
  map.put("lesson_possessivo_suffisso_title", Res.string.lesson_possessivo_suffisso_title)
  map.put("lesson_preposizione_dr_desc", Res.string.lesson_preposizione_dr_desc)
  map.put("lesson_preposizione_dr_title", Res.string.lesson_preposizione_dr_title)
  map.put("lesson_preposizione_hr_desc", Res.string.lesson_preposizione_hr_desc)
  map.put("lesson_preposizione_hr_title", Res.string.lesson_preposizione_hr_title)
  map.put("lesson_preposizione_m_desc", Res.string.lesson_preposizione_m_desc)
  map.put("lesson_preposizione_m_locativa_desc", Res.string.lesson_preposizione_m_locativa_desc)
  map.put("lesson_preposizione_m_locativa_title", Res.string.lesson_preposizione_m_locativa_title)
  map.put("lesson_preposizione_m_title", Res.string.lesson_preposizione_m_title)
  map.put("lesson_recap_frasi_pseudoverbali_desc", Res.string.lesson_recap_frasi_pseudoverbali_desc)
  map.put("lesson_recap_frasi_pseudoverbali_title", Res.string.lesson_recap_frasi_pseudoverbali_title)
  map.put("lesson_recap_imperfettivo_desc", Res.string.lesson_recap_imperfettivo_desc)
  map.put("lesson_recap_imperfettivo_title", Res.string.lesson_recap_imperfettivo_title)
  map.put("lesson_recap_verbi_participi_desc", Res.string.lesson_recap_verbi_participi_desc)
  map.put("lesson_recap_verbi_participi_title", Res.string.lesson_recap_verbi_participi_title)
  map.put("lesson_recap_vso_desc", Res.string.lesson_recap_vso_desc)
  map.put("lesson_recap_vso_title", Res.string.lesson_recap_vso_title)
  map.put("lesson_rieccolo_di_nuovo_desc", Res.string.lesson_rieccolo_di_nuovo_desc)
  map.put("lesson_rieccolo_di_nuovo_title", Res.string.lesson_rieccolo_di_nuovo_title)
  map.put("lesson_ripassino_aggettivi_desc", Res.string.lesson_ripassino_aggettivi_desc)
  map.put("lesson_ripassino_aggettivi_title", Res.string.lesson_ripassino_aggettivi_title)
  map.put("lesson_ripasso_genere_numero_desc", Res.string.lesson_ripasso_genere_numero_desc)
}
